export enum AltTahsilatTuru{
    "kredi_karti_avukat"=1,
    "nakit",
    "kredi_karti_muvekkil",
    "bayi",
    "banka",
    "diger"
}